<template>
  <Teleport to="body">
    <div
      class="overlay"
      :class="{ 'overlay--visible': visible }"
      :inert="!visible"
      @click="emit('click')"
    >
      <slot />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import '@/assets/css/components/_overlay.css'
defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})
const emit = defineEmits(['click'])
</script>
